import { ScreenNames } from './screenMapping';
import { isArkoseGateVerifyOrBypassScreen } from '../arkose-gate-verify-or-bypass/screenMapping';
import { isMfaChallengeScreen } from '../mfa-challenge/screenMapping';
import { isPhoneSmsOtpAuthScreen } from '../phone-sms-otp-auth/screenMapping';

export const PROTECTED_EMAIL_CONFIRMATION_SCREEN_NAMES = [
  ScreenNames.CONFIRM_EMAIL,
  'ProtectedEmailConfirmationScreen',
  'Protected Email Confirmation Screen',
  'Protected Username Email Confirmation',
  'Protected username email confirmation',
] as const;

export const LOGIN_OTP_SCREEN_NAMES = [
  ScreenNames.VERIFY_OTP,
  'Verify email OTP in Login',
] as const;

export const UNIVERSAL_LOGIN_CUSTOM_SCREEN_NAMES = [
  ScreenNames.LOGIN_PAGE,
  ScreenNames.SIGNUP_PAGE,
  ScreenNames.PASSWORD_OTP_LOGIN,
  ...LOGIN_OTP_SCREEN_NAMES,
  ScreenNames.VERIFY_OTP_SIGNUP,
  ScreenNames.CHOOSE_USERNAME_EMAIL_OTP,
  ScreenNames.SOCIAL_SIGNUP_USERNAME,
  ScreenNames.ARKOSE_LOGIN_GATE,
  ScreenNames.ARKOSE_SIGNUP_GATE,
  ScreenNames.ARKOSE_SMS_LOGIN_GATE,
  ScreenNames.ARKOSE_SMS_SIGNUP_GATE,
  ...PROTECTED_EMAIL_CONFIRMATION_SCREEN_NAMES,
] as const;

export const isProtectedEmailConfirmationScreen = (
  screenName?: string
): boolean =>
  Boolean(
    screenName &&
    PROTECTED_EMAIL_CONFIRMATION_SCREEN_NAMES.includes(
      screenName as (typeof PROTECTED_EMAIL_CONFIRMATION_SCREEN_NAMES)[number]
    )
  );

export const isLoginOtpVerificationScreen = (screenName?: string): boolean =>
  Boolean(
    screenName &&
    LOGIN_OTP_SCREEN_NAMES.includes(
      screenName as (typeof LOGIN_OTP_SCREEN_NAMES)[number]
    )
  );

export const isSignupOtpVerificationScreen = (screenName?: string): boolean =>
  screenName === ScreenNames.VERIFY_OTP_SIGNUP;

export const isEmailOtpVerificationScreen = (screenName?: string): boolean =>
  isLoginOtpVerificationScreen(screenName) ||
  isSignupOtpVerificationScreen(screenName);

export const isUniversalLoginCustomScreen = (screenName: string): boolean =>
  UNIVERSAL_LOGIN_CUSTOM_SCREEN_NAMES.includes(
    screenName as (typeof UNIVERSAL_LOGIN_CUSTOM_SCREEN_NAMES)[number]
  ) ||
  isArkoseGateVerifyOrBypassScreen(screenName) ||
  isPhoneSmsOtpAuthScreen(screenName) ||
  isMfaChallengeScreen(screenName);
